import { useGetDossierActiesById } from "@/entities/actie";
import { ActieTijdlijnCard } from "@/features/acties/components/actie-tijdlijn-card";
import { Icon, SidebarGroupContent, SidebarGroupLabel } from "@/shared/components";
import { TimelineEmptyMessage, TimelineEntries, TimelineItem } from "@/shared/components/ui/timeline";
import { AnimatePresence } from "motion/react";

interface ActiesProps {
    dossierNummer: string;
}

export function Acties({ dossierNummer }: ActiesProps) {
    const { data: acties } = useGetDossierActiesById(dossierNummer);

    return (
        <article className="relative">
            <SidebarGroupLabel className="bg-emphasis-primary mb-2 grid grid-cols-[48px_40px_1fr] px-0">
                <Icon name="play" className="col-start-2 justify-self-center" />
                Acties
            </SidebarGroupLabel>
            <SidebarGroupContent>
                <TimelineEntries className="grid gap-2" data-testid="acties-timeline">
                    <AnimatePresence>
                        {!acties || acties.length === 0 ? (
                            <TimelineEmptyMessage>Op dit moment geen acties</TimelineEmptyMessage>
                        ) : (
                            acties.map((actie) => (
                                <TimelineItem key={actie.id} animated>
                                    <ActieTijdlijnCard actie={actie} dossierId={dossierNummer} />
                                </TimelineItem>
                            ))
                        )}
                    </AnimatePresence>
                </TimelineEntries>
            </SidebarGroupContent>
        </article>
    );
}
